import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import MainMenu from './MainMenu';
import { mobileMediaQuery, themeColor, useBreakPoints } from '../Theming';
import { Link } from 'react-router-dom';
import { Path } from '../Routing';
import { KindredForBusinessLogo } from '../Common/Svg/Logos';
import HamburgerMenu from './HamburgerMenu';

const HeaderRoot = styled.header`
  background: ${themeColor('white')};
  z-index: 15;
  position: sticky;
  top: 0;
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  display: flex;
  justify-content: space-between;
  padding: 25.32px 53px 25.32px 53px;
  width: 100%;
  align-items: center;
  height: 96px;
  max-width: 1440px;
  margin: 0 auto;

  ${mobileMediaQuery} {
    grid-template-columns: auto 1fr;
    align-items: center;
    padding: 15px 20px;
    margin: 0 0;
  }
`;

const LogoContainer = styled.div`
  grid-column: 1 / 2;
  margin: 0;

  ${mobileMediaQuery} {
    grid-column: 1 / 2;
  }
`;

const Header: React.FC = () => {
  const { tablet } = useBreakPoints();

  const headerRef = useRef<HTMLElement>(null);

  // This is for the sticky header effect, when scrolling upwards from the bottom of the page
  useEffect(() => {
    let lastScrollY = window.scrollY;
    let top = 0;

    const handler = () => {
      if (headerRef.current) {
        if (window.scrollY < lastScrollY) {
          if (top < 0) {
            const headerHeight = headerRef.current.clientHeight;

            top = Math.min(
              Math.max(-1 * headerHeight, top) + lastScrollY - window.scrollY,
              0
            );
          }
        } else {
          top -= window.scrollY - lastScrollY;
        }

        headerRef.current.style.top = `${top}px`;
      }
      lastScrollY = window.scrollY;
    };

    window.addEventListener('scroll', handler, { passive: true });

    return () => {
      window.removeEventListener('scroll', handler);
    };
  }, [headerRef]);

  return (
    <HeaderRoot ref={headerRef}>
      <Container>
        <LogoContainer>
          <Link to={Path.Home} aria-label="Kindred">
            <KindredForBusinessLogo />
          </Link>
        </LogoContainer>
        {tablet && <HamburgerMenu />}
        {!tablet && <MainMenu />}
      </Container>
    </HeaderRoot>
  );
};

export default Header;
